<template>
  <div class="repair-bill-print">
    <div class="rb-header">
      <img
        src="/media/logos/vdd_hori_logo.png"
        alt="logo"
        class="rb-logo"
      >
      <div class="rb-tagline">
        Hệ thống Mua bán - Thu cũ đổi mới - Sửa chữa
      </div>
      <div class="rb-tagline">
        ĐTDĐ - Tablet - Macbook - Laptop - Phụ kiện
      </div>
      <div class="rb-store-line">
        {{ storeAddress }} <span v-if="storePhone">- {{ storePhone }}</span>
      </div>
    </div>

    <h2 class="rb-title">HÓA ĐƠN DỊCH VỤ</h2>
    <hr class="rb-divider">

    <div class="rb-info-block">
      <div><strong>Tên Khách:</strong> {{ customerName }}</div>
      <div><strong>Số điện thoại:</strong> {{ customerPhone }}</div>
      <div><strong>Sản phẩm:</strong> {{ deviceModel }}</div>
      <div v-if="slip.imei">
        <strong>Imei:</strong> {{ slip.imei }}
      </div>
    </div>

    <hr class="rb-divider">

    <table class="rb-items">
      <thead>
        <tr>
          <th class="rb-col-name">Dịch vụ</th>
          <th class="rb-col-amount text-right">Thành tiền</th>
          <th class="rb-col-warranty text-right">Bảo hành ( tháng )</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(line, idx) in lineItems"
          :key="idx"
        >
          <td>{{ line.name }}</td>
          <td class="text-right">{{ formatMoney(line.amount) }}</td>
          <td class="text-right">{{ line.warrantyMonths || '0' }}</td>
        </tr>
        <tr v-if="lineItems.length === 0">
          <td
            colspan="2"
            class="text-right"
          >{{ formatMoney(totalAmount) }}</td>
          <td></td>
        </tr>
      </tbody>
      <tfoot v-if="lineItems.length > 0">
        <tr class="rb-total-row">
          <th class="text-right">Tổng cộng</th>
          <th class="text-right">{{ formatMoney(totalAmount) }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>

    <hr class="rb-divider">

    <div class="rb-meta">
      <div><strong>Số HĐ:</strong> {{ billNumber }}</div>
      <div><strong>Số Phiếu:</strong> {{ slip.slipNumber || '-' }}</div>
      <div><strong>Ngày:</strong> {{ billDate }}</div>
      <div><strong>Ghi chú :</strong></div>
    </div>

    <div class="rb-policy">
      <div>- VDD chỉ bảo hành những linh kiện đã sửa chữa/thay thế tại VDD và đủ điều kiện:</div>
      <div>+ Máy không cong main, cong sườn, dập nát, cháy nổ, rơi vỡ, vào nước, ẩm mốc, vào hóa chất, chảy mực hoặc bị tác động ngoại lực.</div>
      <div>+ Tem bảo hành còn nguyên vẹn, không bị bong/ rách/ dán đè/ bị sửa đổi.</div>
      <div>+ Không bị tác động/can thiệp/sửa chữa bởi bên thứ 03.</div>
      <div>- Chính sách bảo hành: xem cụ thể tại web: viendiong.com - Hotline: 1800.6729</div>
      <div class="rb-strong">Ghi chú hóa đơn:</div>
      <div>- Hóa đơn chưa bao gồm phí GTGT.</div>
      <div>- Quý khách vui lòng liên hệ cửa hàng để cung cấp thông tin xuất hóa đơn GTGT trong vòng 24h tính từ ngày mua hàng.</div>
    </div>

    <div class="rb-thanks">Xin cảm ơn quý khách!</div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PrintRepairBill',
  props: {
    slip: {
      type: Object,
      default: () => ({}),
    },
    bill: {
      type: Object,
      default: null,
    },
  },
  computed: {
    storeAddress() {
      return (this.bill && this.bill.storeAddress) || '';
    },
    storePhone() {
      return (this.bill && this.bill.storeHotline) || '';
    },
    customerName() {
      return (this.bill && this.bill.customerName) || this.slip.customerName || '-';
    },
    customerPhone() {
      return (this.bill && this.bill.customerPhone) || this.slip.customerPhone || '-';
    },
    deviceModel() {
      const name = this.slip.productName || '';
      const brand = this.slip.brandName ? `${this.slip.brandName} ` : '';
      return `${brand}${name}`.trim() || '-';
    },
    billNumber() {
      return (this.bill && this.bill.billNumber) || '-';
    },
    billDate() {
      // BE đã format sẵn 'HH:mm DD/MM/YYYY' tại billSearchService.getBillInfo
      // (xem createdAtString) — hiển thị thẳng, không re-parse qua moment.
      if (this.bill && this.bill.createdAt) return this.bill.createdAt;
      const fallback = this.slip.returnedAt || this.slip.completedAt || this.slip.createdAt;
      return fallback ? this.formatDate(fallback) : '';
    },
    lineItems() {
      // Render từ BillItems của Hoá đơn dịch vụ (Bill bán lẻ liên kết với phiếu).
      // Dùng totalPrice = productPrice * quantity (chưa trừ discount, chưa cộng VAT) —
      // khớp công thức Bill.totalAmount = sum(totalAmount line) - discountAmount bill.
      const items = (this.bill && this.bill.billItems) || [];
      return items
        .filter((it) => Number(it.productPrice) > 0 && Number(it.quantity) > 0)
        .map((it) => {
          const qty = Number(it.quantity) || 1;
          const price = Number(it.productPrice) || 0;
          const discount = Number(it.discountAmount) || 0;
          return {
            name: `${it.productName || ''}${qty > 1 ? ` (x${qty})` : ''}`,
            amount: qty * price - discount,
            warrantyMonths: Number(it.warrantyMonthNo) || 0,
          };
        });
    },
    totalAmount() {
      if (this.bill && Number(this.bill.totalAmount) > 0) {
        return Number(this.bill.totalAmount);
      }
      return this.lineItems.reduce((s, l) => s + (Number(l.amount) || 0), 0);
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    formatMoney(value) {
      const num = Number(value);
      if (!num) return '0';
      return num.toLocaleString('vi-VN');
    },
  },
};
</script>

<style scoped>
.repair-bill-print {
  width: 148mm;
  margin: 0 auto;
  font-family: 'Times New Roman', serif;
  font-size: 11pt;
  color: #000;
  background: #fff;
  padding: 8mm 6mm;
}
.rb-header {
  text-align: center;
}
.rb-logo {
  max-height: 28mm;
  object-fit: contain;
}
.rb-tagline {
  font-weight: 700;
  font-size: 11pt;
  line-height: 1.3;
}
.rb-store-line {
  font-size: 10pt;
  margin-top: 2px;
}
.rb-title {
  text-align: center;
  font-size: 20pt;
  font-weight: 700;
  margin: 12px 0 4px 0;
}
.rb-divider {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}
.rb-info-block {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-items {
  width: 100%;
  border-collapse: collapse;
  margin: 6px 0;
}
.rb-items th,
.rb-items td {
  padding: 4px 6px;
  vertical-align: top;
  font-size: 11pt;
}
.rb-items thead th {
  border-bottom: 1px solid #000;
  font-weight: 700;
  text-align: left;
}
.rb-col-amount {
  width: 28%;
}
.rb-col-warranty {
  width: 28%;
}
.rb-total-row th {
  border-top: 1px solid #000;
  font-weight: 700;
}
.text-right {
  text-align: right;
}
.rb-meta {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-policy {
  font-size: 10.5pt;
  line-height: 1.5;
}
.rb-strong {
  font-weight: 700;
  margin-top: 4px;
}
.rb-thanks {
  text-align: center;
  font-weight: 700;
  margin-top: 12px;
}
@media print {
  .repair-bill-print {
    padding: 0;
  }
  @page {
    size: A5 portrait;
    margin: 8mm;
  }
}
</style>
